<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="userName" label="客户名称">
              {{ formData.userName || '' }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="specName" label="品种规格">
              {{ formData.specName || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="quantity" label="客户存油数量">
              {{ formData.quantity || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="allQuantity" v-if="formData.ygId" label="存油总数量">
              {{ formData.allQuantity || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygCode" label="关联油罐">
              {{ formData.ygCode || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ctime" label="创建时间">
              {{ formData.ctime || '--' }}

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
export default {
  name: 'CustomerOilStorageDetail',

  data () {
    return {
      formData: {
        storageId: '',
        userId: '',
        specId: '',
        quantity: '',
        ygId: '',
        ctime: ''
      },

      loading: false

    }
  },
  created () {
    if (this.storageId) {
      this.loadData()
    }
  },
  computed: {
    storageId () {
      return this.$route.query.storageId
    }
  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.customerOilStorage.selectYgnCustStorageByStorageId, {
          params: { storageId: this.storageId }
        })
        .then(res => {
          this.formData = res || {}
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
